import React, { Component } from "react";
import prefixAll from "inline-style-prefix-all";
import PropTypes from 'prop-types'
import "./styles.css";
import { colorTertiaryForPrint } from '../../Utils'

export class LookAndFeelLips extends Component {
  state = {
    color: "",
    width: 0,
    height: 0
  };

  onImageLoad = (image) => {
    this.setState({
      height: image.target.offsetHeight,
      width: image.target.offsetWidth
    });
  }

  render() {
    const { image, cropped, state, location } = this.props;
    const { width, height } = this.state

    let rgba = colorTertiaryForPrint(location, state)
    

    if (!image && !cropped) return null;

    return (
      <div data-test="LookAndFeelLips" className="icc-wrapper">

        <div data-test="LookAndFeelLipsPreview" className="icc-preview">
          <img src={image} onLoad={this.onImageLoad} data-test="LookAndFeelLipsOriginal" alt="" className="icc-image-original" />
          <img
            data-test="LookAndFeelLipsCropped"
            className="icc-image-cropped"
            style={prefixAll({
              width: width,
              height: height,
              backgroundImage: `url("${cropped}")`,
              backgroundColor: rgba,
              backgroundBlendMode: "luminosity",
              maskImage: `url("${cropped}")`,
              maskMode: "alpha"
            })}
            alt=""
          />
        </div>

      </div>
    );
  }
}

LookAndFeelLips.propTypes = {
  image: PropTypes.string,
  cropped: PropTypes.string
}

export default LookAndFeelLips;